import moment from "moment";
moment.locale("fr");

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "object" && Object.entries(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};

export const wait = (duration = 1000) => {
  return new Promise((resolve) => {
    window.setTimeout(resolve, duration);
  });
};

export const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

export const capitalizeAll = (s) =>
  s &&
  s
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");

export const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/\//g, "-") // ✅ remplace / par -
    .replace(/\s+/g, "-") // remplace espaces (1 ou +) par -
    .replace(/[^\w-]+/g, "") // enlève caractères spéciaux
    .replace(/--+/g, "-") // évite les doubles tirets
    .replace(/^-+|-+$/g, ""); // trim des tirets
};

export const unSlugify = (text) => {
  return text?.replace(/-/g, " ");
};

export const formatMessageDate = (date) => {
  const now = moment();
  const msg = moment(date);

  if (msg.isSame(now, "day")) return "Today";

  if (msg.isSame(now.clone().subtract(1, "day"), "day")) return "Yesterday";

  const diffDays = now.diff(msg, "days");

  if (diffDays < 7) return msg.format("ddd");

  return msg.format("ddd, DD MMM");
};

export const formatTime = (time) => {
  let hours = Math.floor(time / 3600); // Calcul des heures
  let minutes = Math.floor((time % 3600) / 60); // Calcul des minutes
  let seconds = Math.floor(time % 60); // Calcul des secondes

  // Formattage des heures, minutes et secondes pour s'assurer qu'ils sont sur 2 chiffres
  if (hours < 10) hours = "0" + hours;
  if (minutes < 10) minutes = "0" + minutes;
  if (seconds < 10) seconds = "0" + seconds;

  return hours + ":" + minutes + ":" + seconds;
};

export const convertDuration = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  let result = [];

  if (hours > 0) {
    result.push(`${hours} heure${hours > 1 ? "s" : ""}`);
  }

  if (minutes > 0) {
    result.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
  }

  if (seconds > 0 || result.length === 0) {
    result.push(`${seconds} seconde${seconds > 1 ? "s" : ""}`);
  }

  return result.join(" ");
};

export const formatDuration = (totalSeconds) => {
  if (totalSeconds <= 0 || !Number.isFinite(totalSeconds)) {
    return "0s";
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const parts = [];

  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  return parts.join(" ");
};

export const colors = [
  "#3572EF",
  "#5DEBD7",
  "#F2A51A",
  "#C80036",
  "#604CC3",
  "#0C0C0C",
];

export const randomElement = (arr) =>
  arr[Math.floor(Math.random() * arr.length)];

// Shuffle order of elements in array
export const shuffleArray = (arr) => {
  const result = arr.slice(); // shallow copy to avoid mutation
  for (let i = result.length; i-- > 1; ) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

export const rankingOrder = (val) => {
  if (isEmpty(val)) return;

  let value = val.toString();
  let lastChar = value.slice(-1);

  let _ranking = "";

  if (parseInt(lastChar) === 1) {
    _ranking = "st";
  } else if (parseInt(lastChar) === 2) {
    _ranking = "nd";
  } else if (parseInt(lastChar) === 3) {
    _ranking = "rd";
  } else {
    _ranking = "th";
  }

  return _ranking;
};

export const truncateValue = (text, cutLength) => {
  return text?.length > cutLength ? text.slice(0, cutLength) + "..." : text;
};

export const alphabet = [
  { 1: "A" },
  { 2: "B" },
  { 3: "C" },
  { 4: "D" },
  { 5: "E" },
  { 6: "F" },
  { 7: "G" },
  { 8: "H" },
  { 9: "I" },
  { 10: "J" },
  { 11: "K" },
  { 12: "L" },
  { 13: "M" },
  { 14: "N" },
  { 15: "O" },
  { 16: "P" },
  { 17: "Q" },
  { 18: "R" },
  { 19: "S" },
  { 20: "T" },
  { 21: "U" },
  { 22: "V" },
  { 23: "W" },
  { 24: "X" },
  { 25: "Y" },
  { 26: "Z" },
];

